<template>
	<div>
		<el-card class="box-card">
			<el-form :inline="true">
				<el-form-item label="">
					<el-select filterable clearable v-model="listQuery.search.ck_uid" clearable placeholder="仓库">
						<el-option v-for="item in ck_all" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="">
					<el-input style="width: 100px;" placeholder="年" v-model="listQuery.search.y" clearable> </el-input>
				</el-form-item>
				<el-form-item label="">
					<el-input style="width: 100px;" placeholder="月" v-model="listQuery.search.m" clearable> </el-input>
				</el-form-item>
				<el-form-item label="">
					<el-input style="width: 100px;" placeholder="日" v-model="listQuery.search.d" clearable> </el-input>
				</el-form-item>
			</el-form>
			<el-button type="primary" icon="el-icon-search" @click="keySearch">搜索</el-button>
			<el-button type="primary" plain @click="resetSearch">重置搜索</el-button>
		</el-card>

		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<el-table-column prop="id" label="ID"> </el-table-column>
				<el-table-column prop="ck_uid_name" label="仓库"></el-table-column>
				<el-table-column prop="day" label="日期"> </el-table-column>
				<el-table-column prop="order_num" label="订单数"> </el-table-column>
				<el-table-column prop="create_time" label="统计时间">
					<template slot-scope="{row}">
						<span>{{ row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
		</div>
	</div>
</template>

<script>
	import {
		dayTotal
	} from '@/api/sign_admin'
	import request from '@/tool/request'
	import {
		parseTime,alertMsg
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	export default {
		components: {
			Pagination
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				is_show_search: false, // 搜索模态框
				data_list: [], // 表格数据
				loading: true,
				ck_all: [],
			};
		},
		filters: {
			parseTime,
		},
		created() {
			this.resetSearchData()
			this.getList()
		},
		methods: {
			keySearch() { // 搜索
				this.listQuery.page = 1
				this.getList()
			},

			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: [],
				}
			},
			// 重置搜索
			resetSearch() {
				this.resetSearchData()
				this.getList()
			},
			// 获取列表数据
			getList() {
				this.loading = true;
				dayTotal(Qs.stringify(this.listQuery)).then(response => {
					let r = response.result;
					this.data_list = r.items;
					this.total = r.total;
					if (this.listQuery.page == 1) {
						this.ck_all = r.ck_all;
					}
					this.loading = false;
				})
			},
		}
	}
</script>
